var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.storeInventoryIcon,attrs:{"id":"showStoreFinder"},on:{"click":_vm.showStoreFinder}},[_c('font-awesome-icon',{attrs:{"icon":_vm.storeInventoryIcon}}),_vm._v(" "+_vm._s(_vm.storeInventory))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }